import React, { useState } from "react";
import StarFillIcon from "remixicon-react/StarFillIcon";
import StarLineIcon from "remixicon-react/StarLineIcon";
import cls from "./rating.module.scss";

type Props = {
  value: number;
  onChange?: (value: number) => void;
  count?: number;
  size?: number;
  activeColor?: string;
  hoverColor?: string;
  readonly?: boolean;
  emptyIcon?: React.ReactElement;
  fullIcon?: React.ReactElement;
  centered?: boolean;
};

export default function Rating({
  value,
  count = 5,
  size = 20,
  onChange,
  readonly = false,
  activeColor = "var(--yellow-rating)",
  hoverColor = "var(--yellow-rating)",
  emptyIcon = <StarLineIcon />,
  fullIcon = <StarFillIcon />,
  centered = false,
}: Props) {
  const [hoverValue, setHoverValue] = useState<number | undefined>(undefined);

  const handleMouseMove = (index: number) => {
    if (readonly) {
      return;
    }
    setHoverValue(index);
  };

  const handleMouseLeave = () => {
    if (readonly) {
      return;
    }
    setHoverValue(undefined);
  };

  const handleClick = (index: number) => {
    if (readonly) {
      return;
    }
    if (onChange) {
      onChange(index + 1);
    }
  };

  const getColor = (index: number) => {
    if (hoverValue !== undefined) {
      if (index <= hoverValue) {
        return hoverColor;
      }
    }
    return activeColor;
  };

  const stars = [];

  for (let i = 0; i < count; i++) {
    let star: React.ReactElement;

    if (hoverValue !== undefined) {
      if (i <= hoverValue) {
        star = fullIcon;
      }
    }

    if (i < value) {
      star = fullIcon;
    } else {
      star = emptyIcon;
    }

    if (hoverValue !== undefined) {
      if (i <= hoverValue) {
        star = fullIcon;
      }
    }

    stars.push(
      <button
        type="button"
        className={`${cls.star} ${readonly ? cls.readOnly : ""}`}
        key={i}
        onMouseMove={() => handleMouseMove(i)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(i)}
      >
        {React.cloneElement(star, { size, color: getColor(i) })}
      </button>,
    );
  }

  return (
    <div className={`${centered ? cls.centered : cls.container}`}>{stars}</div>
  );
}
